// extracted by mini-css-extract-plugin
export default {"MyBtn":"MyBtnUnactive_MyBtn__--vY2","active":"MyBtnUnactive_active__S-Ec9","padding":"MyBtnUnactive_padding__XbhLj","rus":"MyBtnUnactive_rus__R8baN"};